export function collapseFormFamilies(forms) {
    const groups = new Map();
    const priority = { current: 3, retired: 2, draft: 1 };
    for (const form of forms) {
        const key = form.familyId == null ? `form:${form.id}` : `family:${form.familyId}`;
        const previous = groups.get(key);
        const rank = priority[form.versionStatus] || 0;
        const previousRank = priority[previous?.versionStatus] || 0;
        if (!previous || rank > previousRank || (rank === previousRank && Number(form.versionNumber) > Number(previous.versionNumber))) groups.set(key, form);
    }
    return [...groups.values()].filter(form => form.versionStatus !== 'draft');
}
